import React, { useEffect, useRef } from 'react';
import './WebReimagine.css';

const cards = [
  {
    id: 1,
    title: 'MARKETING & ADVERTISING',
    desc: 'Smartphone over sheets of paper with marketing strategiesFrom crafting data-driven campaigns to leveraging cutting-edge advertising technologies, empower your brand to thrive in the dynamic landscape of modern marketing.',
    bg: '/images/marketing.avif',
  },
  {
    id: 2,
    title: 'TECHNOLOGY',
    desc: 'Laptop screen showing lines of code with blue backgroundWhether it’s developing SaaS platforms or optimizing customer satisfaction, create tech solutions that not only set you apart but are also pivotal for your digital transformation journey.',
    bg: '/images/technology.avif',
  },
  {
    id: 3,
    title: 'SPORTS',
    desc: 'Runner prepared to start an official runRevolutionize the sports industry by enhancing fan engagement through mobile apps or optimizing athlete performance with data analytics. We support you to drive innovation across the entire sports ecosystem.',
    bg: '/images/sports.avif',
  },
];

const ReimagineSection = () => {
  const refs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    refs.current.forEach(ref => ref && observer.observe(ref));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="reimagine-section">
      <div className="reimagine-header983">
        <h2 className="fade-left" ref={el => refs.current[0] = el}>
          WE HELP <span className="blue"><br/>REIMAGINE <br/>INDUSTRIES</span>
        </h2>
        <p className="fade-right" ref={el => refs.current[1] = el}>
         Since 2010, we’ve accerelated more than 300 web, software and mobile application services.
        </p>
      </div>

      <div className="reimagine-cards">
        {cards.map((card, i) => (
          <div
            className="reimagine-card fade-up"
            key={card.id}
            ref={el => refs.current[i + 2] = el}
            style={{ backgroundImage: `url(${card.bg})` }}
          >
            <div className="card-overlay762">
              <h3 className="card-title762">{card.title}</h3>
              <div className="card-hover-content">
                <p>{card.desc}</p>
                <span className="explore-arrow">→ EXPLORE</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="reimagine-btn">
        <button>SEE ALL INDUSTRIES</button>
      </div>
    </section>
  );
};

export default ReimagineSection;
